import type {
  SubmissionField,
  SubmissionGroup,
  SubmissionItem,
  SubmissionSection,
} from "./originalSubmissionSections";

function isCaptured(field: SubmissionField): boolean {
  return field.kind !== "notCaptured";
}

function capturedItem(item: SubmissionItem): SubmissionItem {
  return { fields: item.fields.filter(isCaptured) };
}

function capturedGroup(group: SubmissionGroup): SubmissionGroup {
  const items = group.items.map(capturedItem).filter(item => item.fields.length > 0);
  return { ...group, items };
}

function capturedSection(section: SubmissionSection): SubmissionSection {
  return {
    ...section,
    fields: section.fields.filter(isCaptured),
    groups: section.groups.map(capturedGroup).filter(group => group.items.length > 0),
    notCapturedItemFields: [],
  };
}

/** The sections with every Not captured field removed; Not provided fields stay. */
export function capturedOnly(sections: SubmissionSection[]): SubmissionSection[] {
  return sections.map(capturedSection);
}
